import type { HistoryDateFilter, Language } from '@/shared/types';
import type { PaidInvoicesFormValues } from '../model';

const getDefaultFormValues = (
  language: Language,
  defaultDateFilter: HistoryDateFilter | undefined,
  dateFrom?: Date,
  dateTo?: Date,
  formValues?: PaidInvoicesFormValues
): PaidInvoicesFormValues => {
  const baseValues: PaidInvoicesFormValues = {
    lang: formValues?.lang || language,
    datefilter: formValues?.datefilter || defaultDateFilter,
    datefrom: formValues?.datefrom,
    dateto: formValues?.dateto,
  };

  if (dateFrom && dateTo) {
    return {
      ...baseValues,
      datefilter: 'custom',
      datefrom: dateFrom,
      dateto: dateTo,
    };
  }

  if (
    baseValues.datefilter === 'custom' &&
    !(baseValues.datefrom && baseValues.dateto)
  ) {
    return { ...baseValues, datefilter: defaultDateFilter };
  }

  return baseValues;
};

export { getDefaultFormValues };
